/**
 * The docs page's text in each of the dashboard's languages. The page carries
 * its own whole texts rather than one translation key per sentence, so each
 * language reads as a document. A language added to `LANGUAGES` does not
 * compile until it has its docs here.
 */

import { type Language, useLanguage } from "@/lib/i18n/language";

import { en } from "./en";
import { fr } from "./fr";
import { nl } from "./nl";
import type { DocsContent } from "./types";

export const docsContent: Record<Language, DocsContent> = { nl, en, fr };

/** The docs in the dashboard's language; re-renders when it switches. */
export function useDocsContent(): DocsContent {
  return docsContent[useLanguage()];
}

export * from "./types";
